import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { Title } from '../../../../shared/ModalComponents';
import { BaseInput, Label as BaseLabel } from '../../../../shared/FormStyles';

export const StyledTitle = styled(Title)`
  margin: 0 0 12px;
`;

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Label = styled(BaseLabel)`
  margin-bottom: 8px;
  margin-top: 4px;
`;

export const Input = styled(BaseInput)`
  margin: 0 0 16px 0 !important;
  border: 1px solid ${themeGet('colors.black.20')} !important;
`;

export const Information = styled.i`
  margin: 0 4px;
`;
